/**
 * Format a project consistently with its human-readable name first.
 *
 * @param {string|null|undefined} projectName
 * @param {string|null|undefined} projectCode
 * @returns {string}
 */
export const formatProjectLabel = (projectName, projectCode) => {
  const name = (projectName || '').trim();
  const code = (projectCode || '').trim();
  if (!name && !code) return '';
  if (name && code) return `${name} · ${code}`;
  return name || code;
};

const PROJECT_CODE_BY_SITE_LABEL = {
  '18 Office': 'P0000-018',
  '18 Factory': 'P0000-018',
  '38 Office': 'P0000-038',
  '38 Factory': 'P0000-038',
};

/**
 * Normalize historical combined project strings to "Project name · code".
 *
 * Historical CourseRequest rows stored "code - name" in one field. New rows
 * use the canonical label directly, while this parser keeps old rows readable.
 *
 * @param {string|null|undefined} value
 * @returns {string}
 */
export const formatStoredProjectLabel = (value) => {
  const label = (value || '').trim();
  if (!label) return '';
  if (label.includes(' · ')) return label;
  if (PROJECT_CODE_BY_SITE_LABEL[label]) {
    return formatProjectLabel(label, PROJECT_CODE_BY_SITE_LABEL[label]);
  }

  const legacyParts = label.split(/\s[-–—]\s/);
  if (legacyParts.length >= 2) {
    const [projectCode, ...nameParts] = legacyParts;
    return formatProjectLabel(nameParts.join(' - '), projectCode);
  }

  const parenthesized = label.match(/^(.*?)\s+\(([^()]+)\)$/);
  if (parenthesized) {
    return formatProjectLabel(parenthesized[1], parenthesized[2]);
  }

  return label;
};
